import { render } from "./App.vue?vue&type=template&id=3502b7bf"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3502b7bf&lang=less"

import exportComponent from "../node_modules/.pnpm/vue-loader@https+++registry.npmmirror.com+vue-loader+-+vue-loader-17.4.2.tgz_@vue+compiler-sf_f3mcg26kftpnf66glmlsnhcn4m/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__